if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.variantIdInput.disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector("span");

        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";

        const productAttributesEl = this.querySelector("product-attributes");
        if (productAttributesEl) {
          productAttributesEl.querySelectorAll("select").forEach((select) => {
            select.addEventListener("change", () =>
              this.validateSelectAttribute(select),
            );
          });
        }
      }

      validateSelectAttribute(attribute) {
        const selectErrorContainer = attribute.closest(
          "[data-select-error]",
        );
        const isEmpty =
          attribute.value === "" ||
          attribute.value === null ||
          attribute.value === "Select";

        if (isEmpty && attribute.required) {
          attribute.classList.add("border-red");
          attribute.style.borderColor = "#da2b1f";
          if (selectErrorContainer) selectErrorContainer.dataset.error = "true";
          return false;
        }

        attribute.classList.remove("border-red");
        attribute.style.borderColor = attribute.required ? "#2563eb" : "";
        if (selectErrorContainer) selectErrorContainer.dataset.error = "false";
        return true;
      }

      includeAddons(variants) {
        const config = fetchConfig();
        let formData = {
          items: variants,
        };
        config.body = JSON.stringify(formData);
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (!response.status) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                cartData: response,
              });
            }
          })
          .catch((e) => {
            console.error(e);
          });
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading__spinner").classList.remove("hidden");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];
        const productAttributes = this.querySelector("product-attributes");

        if (productAttributes) {
          let validated = true;
          const selectedAttributes =
            productAttributes.querySelectorAll("select, input");
          selectedAttributes.forEach((attribute) => {
            switch (attribute.type) {
              case "select-one": {
                if (!this.validateSelectAttribute(attribute)) {
                  validated = false;
                }
                break;
              }
              case "checkbox":
                if (attribute.required) {
                  if (!attribute.checked) {
                    validated = false;
                    attribute.classList.add("border-red");
                    attribute.parentElement.dataset.error = "true";
                  } else {
                    attribute.classList.remove("border-red");
                    attribute.parentElement.dataset.error = "false";
                  }
                }
                break;
              default:
                break;
            }
          });
          if (!validated) {
            this.submitButton.removeAttribute("aria-disabled");
            this.submitButton.classList.remove("loading");
            this.querySelector(".loading__spinner").classList.add("hidden");
            return;
          }
        }

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id),
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        config.body = formData;
        const productVariantID = formData.get("id");

        if (formData.get("properties[_core_charge]")) {
          formData.set("properties[_core_charge]", productVariantID);
        }

        const addonVariants = [];
        this.form.querySelectorAll("[data-addon-item]").forEach((addon) => {
          if (addon.type == "checkbox") {
            if (addon.checked) {
              const item = {
                id: addon.value,
                quantity: 1,
                properties: {
                  'Part Number': addon.dataset.partNumber,
                },
              };
              if (addon.dataset.coreCharge) {
                item.properties._core_charge = productVariantID;
              }

              addonVariants.push(item);
            }
          } else {
            if (
              addon.value !== "" &&
              addon.value !== null &&
              addon.value !== "Select"
            ) {
              const item = {
                id: addon.value,
                quantity: 1,
              };
              const partNumber = addon?.options[addon.selectedIndex]?.dataset?.partNumber;
              if (partNumber) {
                item.properties = {
                  'Part Number': partNumber,
                };
              }
              addonVariants.push(item);
            }
          }
        });

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButtonText.classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
                cartData: response,
              });
            this.error = false;
            if (addonVariants.length > 0) {
              this.includeAddons(addonVariants);
            }
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true },
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading__spinner").classList.add("hidden");
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message",
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute("disabled", "disabled");
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute("disabled");
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector("[name=id]");
      }
    },
  );
}